import { configureStore } from "@reduxjs/toolkit";
import hotelSlice from "./Slice/hotelSlice";
import appState from "./Slice/state";
import userSlice from "./Slice/userSlice";
import yieldSheet from "./Slice/yieldssheetSlice";

export const store = configureStore({
  reducer: {
    hotelData: hotelSlice,
    appState: appState,
    user: userSlice,
    yieldSheet: yieldSheet,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
